import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import {
  createBrowserRouter,
  RouterProvider,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import MainRoutes from "./routes.tsx";
import { ThemeProvider } from "./lib/theme-provider";
import { Toaster } from "./components/ui/sonner";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop.tsx";
import { NavigationProgress } from "./components/navigation-progress.tsx";
import ReferralCapture from "./components/ReferralCapture.tsx";
import { RootErrorBoundary } from "./components/root-error-boundary";
import { captureFbclid } from "./lib/meta-attribution";
// Escuta o aviso de instalação do Android desde o início: ele chega antes de
// a parte interna do app carregar (lib/install-app.ts)
import "./lib/install-app";

// Antes de renderizar qualquer coisa: o `fbclid` só existe na primeira URL da
// sessão e some no primeiro clique interno. Fora do React de propósito — o
// StrictMode monta os componentes duas vezes, e isto precisa rodar uma só.
captureFbclid();

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="/*"
      element={
        <>
          <ScrollToTop />
          <ReferralCapture />
          <NavigationProgress />
          <MainRoutes />
        </>
      }
      errorElement={<RootErrorBoundary />}
    />
  )
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider defaultTheme="light" storageKey="ecclesiato-theme">
        <RouterProvider router={router} />
        <Toaster />
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
);
